module.exports = __webpack_public_path__ + "staticcomp/img/content_1.bfddadf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/10/content_1.jpg
// module id = sfoc
// module chunks = 39